import { useTranslation } from "react-i18next";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/useTypedSelector";
import {
  clear,
  getCar,
  setLoading,
} from "../../infrastructure/slices/carMutateSlice";
import { CarMutateForm } from "../features/carMutateForm";
import {
  BreadCrumbItem,
  Breadcrumb,
} from "../../../general/modules/commons/breadcrumb/breadcrumb";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";

export const CarMutatePage = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation("common");

  const { id } = useParams();

  const { car, loading } = useAppSelector((state) => state.carMutate);

  useEffect(() => {
    if (id !== undefined) {
      void dispatch(getCar(id));
    } else {
      dispatch(setLoading(false));
    }

    return () => {
      dispatch(clear());
    };
  }, [id]);

  const title = id
    ? t("car.mutate.edit", { licencePlate: car?.licencePlate })
    : t("car.mutate.create");

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} loading={loading} />
          <Breadcrumb>
            <BreadCrumbItem to="/tire-sets">{t(`Tire sets`)}</BreadCrumbItem>
            {car && <BreadCrumbItem>{car.licencePlate}</BreadCrumbItem>}
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>{!loading && <CarMutateForm />}</LayoutContent>
    </Layout>
  );
};
